import React from 'react';
import './FilterButton.css';

const FilterButton = ({ label, isActive, onClick, count }) => {
  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick && onClick(e);
  };

  return (
    <button
      type="button"
      className={`filter-option flex justify-content-between ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >

      <span className='text-capitalize'> {label}</span>
      <span> {count !== undefined && `(${count})`}</span>
    </button>
  );
};

export default FilterButton;



